import Vue from 'vue';
import 'es6-promise/auto';
import Vuex from 'vuex';
import mapping from './modules/mapping';
// import operation from './modules/operation';
import todo from './modules/todo';
// import info from './modules/info';
import team from './modules/team';
import auction from './modules/auction';
import user from './modules/user';
import newuser from './modules/newuser';
 import calendar from './modules/calendar'
// import auctionmapping from './modules/auctionmapping'

// import idealista from './modules/idealista';
import custom from './modules/custom';
import upload from './modules/upload';
// import feed from './modules/feed';
// import dashboard from './modules/dashboard';
// import help from './modules/help';
// import settings from './modules/settings';
import errors from './modules/errors';
import customfree from './modules/customfree';
import customfreeauction from './modules/customfreeauction';
// import pills from './modules/pills';
import rating from './modules/rating';
import stats from './modules/stats';
import coach from './modules/coach';
// import buildingimport from './modules/buildingimport';
import track from './modules/track';

// Version 2.x
import n_dashboard from '@/storing/n_storing/n_dashboard';
import n_trash from '@/storing/n_storing/n_trash';
import n_mapping from '@/storing/n_storing/n_mapping';
import n_auction from '@/storing/n_storing/n_auction';
import n_team from '@/storing/n_storing/n_team';
import n_feed from '@/storing/n_storing/n_feed';
import n_pills from '@/storing/n_storing/n_pills';
import n_track from '@/storing/n_storing/n_track';
import n_calendar from '@/storing/n_storing/n_calendar';
import n_income_mapping from '@/storing/n_storing/n_income_mapping';
import n_user from '@/storing/n_storing/n_user';
import n_tutorial from '@/storing/n_storing/n_tutorial';
import n_todo from '@/storing/n_storing/n_todo';
import n_supercoach from '@/storing/n_storing/n_supercoach';
import n_github  from "@/storing/n_storing/n_github";
import n_compravendita from "@/storing/n_storing/n_compravendita";
import n_idealista from "@/storing/n_storing/n_idealista";
import n_catasto from "@/storing/n_storing/n_catasto";
import n_wallet from "@/storing/n_storing/n_wallet";

Vue.use(Vuex);

export const store = new Vuex.Store({

    getters: {

    },
    mutations: {

    },
    actions: {

    },
    modules: {
          mapping,
        todo,
        // operation,
        // info,
         team,
        auction,
        user,
        newuser,
         calendar,
     //   tvalutation,
     //    idealista,

        custom,
        upload,
        // feed,
        // dashboard,
        // help,
        // settings,
        errors,
        customfree,
        customfreeauction,
        // pills,
        rating,
        stats,
        coach,
        // buildingimport,
        track,
        // auctionmapping,

        n_dashboard,
        n_mapping,
        n_auction,
        n_team,
        n_feed,
        n_pills,
        n_track,
        n_calendar,
        n_income_mapping,
        n_user,
        n_tutorial,
        n_todo,
        n_supercoach,
        n_github,
        n_trash,
        n_compravendita,
        n_idealista,
        n_catasto,
        n_wallet,
    }
});
